import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { CatalogoGeneralDetalleDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class CatalogoGeneralDetalleService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getCatalogoGeneralDetalleService(): Observable<
    BodyListResponse<CatalogoGeneralDetalleDTO>
  > {
    return this.http.get<BodyListResponse<CatalogoGeneralDetalleDTO>>(
      API_URL + '/api/v1/catalogoGeneralDetalle/todos',
    );
  }

  guardarCatalogoGeneralDetalleService(
    catalogoGeneralDetalleDTO: CatalogoGeneralDetalleDTO,
  ): Observable<BodyResponse<CatalogoGeneralDetalleDTO>> {
    return this.http.post<any>(
      API_URL + '/api/v1/catalogoGeneralDetalle',
      catalogoGeneralDetalleDTO,
    );
  }

  getCatalogoGeneralDetallePorCodigoService(
    codigo: string,
  ): Observable<BodyResponse<CatalogoGeneralDetalleDTO>> {
    return this.http.get<BodyResponse<CatalogoGeneralDetalleDTO>>(
      API_URL + '/api/v1/catalogoGeneralDetalle/' + codigo,
    );
  }
  // obtener listado de catalogo general detalle por codigo general
  getCatalogoGeneralDetallePorCatalogoGeneralService(
    codigo: string,
  ): Observable<BodyListResponse<CatalogoGeneralDetalleDTO>> {
    return this.http.get<BodyListResponse<CatalogoGeneralDetalleDTO>>(
      API_URL + '/api/v1/catalogoGeneralDetalle/catalogoGeneral/' + codigo,
    );
  }

  obtenerCatalogoGeneralDetallePorCatalogoGeneralService(
    codigoBusqueda: string,
  ): Observable<BodyListResponse<CatalogoGeneralDetalleDTO>> {
    return this.http.get<BodyListResponse<CatalogoGeneralDetalleDTO>>(
      API_URL +
        '/api/v1/catalogoGeneralDetalle/catalogoGeneral/codigoUnico/' +
        codigoBusqueda,
    );
  }
}
